import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage as FM } from 'react-intl';
import classNames from 'classnames';

import BaseStaticSelect from '../BaseStaticSelect';

import { staticStyles } from './style';

const InputIntegerChoice = ({ isDisabled, name, multi, options, onSelect, isNew, withInput, onInputChange }) => {
  const modifedOptions = useMemo(() => {
    const result = options.map(({ name, value, isSelected }) => ({ label: name, value, isSelected }));
    return result;
  });

  return (
    <div className="InputIntegerChoice">
      <div
        className={classNames('InputIntegerChoice__Title', {
          'InputIntegerChoice__Title--disabled': !options?.length,
        })}>
        <FM id={name}>{txt => <span className="InputIntegerChoice__Title-text">{txt}</span>}</FM>
      </div>
      <BaseStaticSelect
        isDisabled={isDisabled}
        onInputChange={onInputChange}
        withInput={withInput}
        labelTextId={name}
        multi={multi}
        fastFilter
        options={modifedOptions}
        onSelect={onSelect}
        isNew={isNew}
        dropDownTitle={name}
      />
      <style jsx>{staticStyles}</style>
    </div>
  );
};

InputIntegerChoice.propTypes = {
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  multi: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isNew: PropTypes.bool,
};

InputIntegerChoice.defaultProps = {
  multi: false,
  isNew: false,
  isDisabled: false,
};

export default InputIntegerChoice;
